module.exports = __webpack_public_path__ + "img/ContactBook.2b055a4b.svg";